__turbopack_context__.v({
  "creatorOverviewChannels": "creator-reports-module__RBtsrG__creatorOverviewChannels",
  "creatorReportsContent": "creator-reports-module__RBtsrG__creatorReportsContent",
  "creatorReportsOverview": "creator-reports-module__RBtsrG__creatorReportsOverview",
  "legendTable": "creator-reports-module__RBtsrG__legendTable",
  "reportsPerformance": "creator-reports-module__RBtsrG__reportsPerformance",
  "tabContent": "creator-reports-module__RBtsrG__tabContent",
  "tabs": "creator-reports-module__RBtsrG__tabs",
});
